import React, { Component } from 'react';
import './toolbar.css';

class SearchClic extends Component {
    constructor(props){
        super(props);
    }

    handleBuscar = () => {
        if (this.buscar) {
            this.props.buscar(this.buscar.value);
        }
    }

    render() {
        const { buscar, buscador, placeholder } = this.props;
        return (
            <div className="col-12 toolbar-search p-0">
                {(buscador !== undefined && buscar !== undefined) && (
                    <div className="contenedor-search">
                        <input
                            id="buscar"
                            type="text"
                            name="buscar"
                            placeholder={placeholder}
                            ref={node => {
                                this.buscar = node;
                                if (this.buscar) {
                                this.buscar.value = buscador;
                                }
                            }}
                            onKeyPress={(event) => {
                                if (event.key === 'Enter') {
                                    this.handleBuscar();
                                }
                            }}
                            autoComplete="off"
                            className="form-control"/>

                        <button
                            type="button"
                            className="btn-lupa"
                            onClick={this.handleBuscar}
                            aria-label="Buscar"
                            >
                            <i className="fa fa-search"></i>
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default SearchClic;